// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as SuspensionDaysRowCmp from "./SuspensionDaysRowCmp.bs.js";
import * as CancellationScoreRowCmp from "./CancellationScoreRowCmp.bs.js";

function SuspensionGuideTableCmp(Props) {
  var thresholds = Props.thresholds;
  var action_value = Props.action_value;
  var max_score = Props.max_score;
  var table_details = Props.table_details;
  return React.createElement("div", {
              className: "suspension-guide-content-container"
            }, React.createElement("table", {
                  className: "suspension-guide-table"
                }, React.createElement("tbody", undefined, React.createElement(CancellationScoreRowCmp.make, {
                          thresholds: thresholds,
                          table_details: table_details,
                          max_score: max_score
                        }), React.createElement(SuspensionDaysRowCmp.make, {
                          table_details: table_details,
                          action_value: action_value
                        }))));
}

var make = SuspensionGuideTableCmp;

export {
  make ,
  
}
/* react Not a pure module */
